import Button from "components/base/Button";
import LeadProfileCard from "components/cards/LeadProfileCard";
import PhoenixOffcanvas from "components/base/PhoenixOffcanvas";
import { useBreakpoints } from "providers/BreakpointsProvider";
import Unicon from "components/base/Unicon";
import { UilTimes } from "@iconscout/react-unicons";
import EnhancedLeadInsights from "components/cards/EnhancedLeadInsights";
import { Card } from "react-bootstrap";
import LeadCalendar from "components/cards/LeadCalendar";

const LeadDetailsOffcanvas = ({ open, setOpen, leadDetails }: any) => {
  const { breakpoints } = useBreakpoints();

  return (
    <>
      {breakpoints.down("md") && (
        <PhoenixOffcanvas
          open={open}
          onHide={() => setOpen(false)}
          style={{ maxWidth: 390 }}
          className="p-4 pt-3 phoenix-offcanvas-content scrollbar"
          placement="start"
          fixed
        >
          <div>
            <div className="d-flex justify-content-between align-items-center mb-2 d-md-none">
              <h3 className="mb-0">Lead Details</h3>
              <Button className="p-0" onClick={() => setOpen(false)}>
                <Unicon icon={UilTimes} />
              </Button>
            </div>

            <LeadProfileCard leadDetails={leadDetails} className="mb-3" />
            <EnhancedLeadInsights className="mb-3" leadDetails={leadDetails} />
            <Card>
              <Card.Body className="d-flex justify-content-center">
                <LeadCalendar />
              </Card.Body>
            </Card>
          </div>
        </PhoenixOffcanvas>
      )}
    </>
  );
};

export default LeadDetailsOffcanvas;
